import React from 'react'
import logUtil from 'utils/log'
import Pagination from 'containers/QuickShopProductSidebar/components/Reviews/components/Pagination'
import ReviewCard from 'containers/QuickShopProductSidebar/components/Reviews/components/ReviewCard'
import Stars from 'containers/QuickShopProductSidebar/components/Reviews/components/Stars'
import extractReviewsFromHtml from 'containers/QuickShopProductSidebar/components/Reviews/utils/extract-reviews-from-html'
import WriteReview from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview'

import './index.css'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const ENDPOINT = 'https://judge.me/reviews/reviews_for_widget'
const DOMAIN = 'goairshop.myshopify.com'

const PER_PAGE = 10
const TOTAL_STARS = 5

const ANALYTICS_EVENT = {
  SHOW_QUICK_SHOP_REVIEWS: 'SHOW_QUICK_SHOP_REVIEWS'
}

const WRITE_REVIEW_TEXT = 'Write a review'
const CANCEL_REVIEW_TEXT = 'Cancel review'

const Reviews = ({
  productId,
  productVariant
}) => {
  const [listOfReviews, setListOfReviews] = React.useState()
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalReviews, setTotalReviews] = React.useState(0)
  const [isWriteReviewOpen, setIsWriteReviewOpen] = React.useState(false)
  const [isReviewSubmitted, setIsReviewSubmitted] = React.useState(false)

  logUtil('ReviewsQuickShop').debug('[start]=', {
    isWriteReviewOpen,
    isReviewSubmitted
  })

  const handleWriteReview = (event) => {
    event.preventDefault()
    if (isReviewSubmitted) {
      setIsReviewSubmitted(false)
      return
    }
    setIsWriteReviewOpen(!isWriteReviewOpen)
    setIsReviewSubmitted(false)
  }

  const handleCloseWriteReview = (event) => {
    event.preventDefault()
    setIsWriteReviewOpen(false)
    setIsReviewSubmitted(false)
  }

  const fetchReviews = () => {
    const url = new URL(ENDPOINT)
    url.searchParams.append('url', DOMAIN)
    url.searchParams.append('shop_domain', DOMAIN)
    url.searchParams.append('platform', 'shopify')
    url.searchParams.append('page', currentPage)
    url.searchParams.append('per_page', PER_PAGE)
    url.searchParams.append('product_id', productId)

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }

        logUtil('ReviewsQuickShop').debug('[response]=', response)
        return response.json()
      })
      .then(data => {
        logUtil('ReviewsQuickShop').debug('[data]=', data)
        const reviewsData = extractReviewsFromHtml(data.html)
        setTotalReviews(data.total_count)
        logUtil('ReviewsQuickShop').debug('[data]=', reviewsData)
        setListOfReviews(reviewsData)
      })
      .catch(error => {
        console.error('Error:', error.message)
      })
  }

  React.useEffect(() => {
    if (totalReviews) {
      logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_QUICK_SHOP_REVIEWS)
    }
  }, [totalReviews])

  React.useEffect(() => {
    fetchReviews()
  }, [
    currentPage,
    productVariant
  ])

  if (totalReviews < 1) {
    return <></>
  }

  const rating = productVariant?.review_info?.rating
  return (
    <div id='quick-shop-reviews'>
      <div className='jdgm-rev-widg__header header-wrapper'>
        <h2 className='review-header-text'>
          Customer Reviews
        </h2>
        <div className='stars-and-stat-container'>
          <span className='stars-container'>
            <Stars
              maxStars={TOTAL_STARS}
              rating={Math.round(rating)}
            />
          </span>
          <div>{`${rating} out of ${TOTAL_STARS}`}</div>
        </div>

        <div className='reviews-footer-container'>
          <div className='jdgm-rev-widg__summary'>
            {`Based on ${totalReviews} review${totalReviews !== 1 ? 's' : ''}`}
          </div>

          <a
            onClick={handleWriteReview}
            href='#'
            class='write-review-link'
            role='button'
            aria-expanded='false'
          >
            {isWriteReviewOpen && !isReviewSubmitted ? CANCEL_REVIEW_TEXT : WRITE_REVIEW_TEXT}
          </a>
        </div>

      </div>

      {isWriteReviewOpen && (
        <WriteReview
          onClose={handleCloseWriteReview}
          productId={productId}
          isReviewSubmitted={isReviewSubmitted}
          setIsReviewSubmitted={setIsReviewSubmitted}
        />
      )}

      {
        listOfReviews?.map((review, index) => {
          return (
            <ReviewCard
              review={review}
              key={index}
            />
          )
        })
      }

      {
        totalReviews > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalReviews / PER_PAGE)}
            onPageChange={setCurrentPage}
          />
        )
      }
    </div>
  )
}

export default Reviews
